<template>
  <div class="examinto-mobile">
    <div class="paradigm_page_container">
      <div class="paradigm_home_product">
        <div class="paradigm_home_subTitle">
          <div class="paradigm_home_subTitle__title">赛码考试平台特色</div>
          <div class="paradigm_home_subTitle__memo">
            多快好省，3分钟搞定一场考试
          </div>
        </div>
        <el-carousel indicator-position="none" :interval="5000" arrow="always">
          <el-carousel-item>
            <div class="paradigm_home_product__content">
              <div class="paradigm_home_product__list__item">
                <span>01</span
                ><span class="paradigm_home_product__list__item__symble">/</span
                ><span>功能强大 / 高并发稳定</span>
              </div>
              <div class="paradigm_home_product__mac">
                <div class="paradigm_home_product__mac__containner">
                  <div class="map1">
                    <img src="@/static/images/home-three-1-map.png" />
                  </div>
                </div>
                <div class="paradigm_home_product__text__containner flex-r-cc">
                  <ul class="txt_info font-desc">
                    <li>
                      <span>支持多种模式：</span
                      >PC、移动端作答，10种考试题型，集中考试/随来随考等12种考试模式；
                    </li>
                    <li>
                      <span>快捷安排考试：</span
                      >智能题库，灵活组卷、考生试题一键导入、精准通知、自动判分，智能统计分析等；
                    </li>
                    <li>
                      <span>在线编译技术：</span
                      >支持20种语言在线编程自动判题，完美解决IT人才技能评定；
                    </li>
                    <li>
                      <span>高并发稳定：</span
                      >系统阿里云部署，弹性云服务器，支持30万考生同时在线，国家等保三级认证。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="paradigm_home_product__content">
              <div class="paradigm_home_product__list__item">
                <span>02</span
                ><span class="paradigm_home_product__list__item__symble">/</span
                ><span>AI智能防作弊与监考</span>
              </div>
              <div class="paradigm_home_product__mac">
                <div class="paradigm_home_product__mac__containner">
                  <div class="map1">
                    <img src="@/static/images/home-three-2-map.png" />
                  </div>
                </div>
                <div class="paradigm_home_product__text__containner flex-r-cc">
                  <ul class="txt_info font-desc">
                    <li>
                      <span>基本手段：</span
                      >随机抽题，试题乱序、水印，自拍存档，防切屏，手机锁屏禁用，内容比对等；
                    </li>
                    <li>
                      <span>进阶手段：</span
                      >人脸识别，电脑正面、手机侧后方、电脑录屏三机位同时视频监控；
                    </li>
                    <li>
                      <span>智能利器：</span
                      >赛码AI抓作弊机器人，通过图像/声音大数据智能分析，识别出作弊嫌疑人；
                    </li>
                    <li>
                      <span>监考大厅：</span
                      >所有考生实时视频监控，作弊嫌疑警示，1对1红牌警告，替考警示等。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="paradigm_home_product__content">
              <div class="paradigm_home_product__list__item">
                <span>03</span
                ><span class="paradigm_home_product__list__item__symble">/</span
                ><span>在线测评/专业大题库</span>
              </div>
              <div class="paradigm_home_product__mac">
                <div class="paradigm_home_product__mac__containner">
                  <div class="map1">
                    <img src="@/static/images/home-three-3-map.png" />
                  </div>
                </div>
                <div class="paradigm_home_product__text__containner flex-r-cc">
                  <ul class="txt_info font-14">
                    <li>
                      人才测评和专业能力考核，一场考试即可全部搞定。支持岗位胜任力、团队合作测评；
                      赛码可按客户要求，进行定制出题服务，目前题库涵盖：IT研发类，行测类，金融类等
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="paradigm_home_product__content">
              <div class="paradigm_home_product__list__item">
                <span>04</span
                ><span class="paradigm_home_product__list__item__symble">/</span
                ><span>考试运营服务</span>
              </div>
              <div class="paradigm_home_product__mac">
                <div class="paradigm_home_product__mac__containner">
                  <div class="map1">
                    <img src="@/static/images/home-three-4-map.png" />
                  </div>
                </div>
                <div class="paradigm_home_product__text__containner flex-r-cc">
                  <ul class="txt_info font-14">
                    <li>
                      赛码可代客户运营考试，设计考试方案、录题组卷，通知考生，监考答疑，出成绩报告等；
                      客户只需把考生名单给我们，剩下的事情都可以放心交给赛码来办。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 1,
    }
  },
  created() {},
  mounted() {},
  methods: {
    viewDetail() {
      this.$router.push('/product/exam')
    },
    mouseoverHandler(num) {
      this.isActive = num
    },
  },
}
</script>
<style lang="scss" scoped>
.paradigm_page_container {
  margin: 0px auto;
  width: 100%;
  padding-top: 32px;
  .slow {
    animation-duration: 2s;
  }
  .tiyanbtn {
    padding: 50px 0px 0px;
    cursor: pointer;
  }
  .tiyanbtn a {
    padding: 8px 15px;
    background: #29bdb9;
    color: #fff;
    border-radius: 20px;
  }
  .paradigm_home_subTitle {
    font-size: 28px;
    font-weight: 300;
    padding: 0px 0px 30px;
    text-align: center;
  }
  .paradigm_home_product .paradigm_home_product__list__item {
    line-height: 49px;
    cursor: pointer;
    font-size: 20px;
    color: #333;
    font-weight: 300;
    transition: all 0.1s;
  }
  .paradigm_home_product__list__item.active
    .paradigm_home_product__list__item__symble {
    transform: rotate(70deg);
    margin-top: -5px;
    vertical-align: top;
    padding-left: 20px;
  }
  .paradigm_home_subTitle .paradigm_home_subTitle__memo {
    margin-top: 10px;
    font-size: 14px;
    color: #999;
  }
  .paradigm_home_product .paradigm_home_product__content {
  }
  .paradigm_home_product .paradigm_home_product__left {
    width: 500px;
    padding-top: 74px;
    box-sizing: border-box;
  }
  .paradigm_home_product .paradigm_home_product__mac {
    width: 100%;
    height: 470px;
    background-size: cover;
    background-position: center;
  }
  .paradigm_home_product
    .paradigm_home_product__mac
    .paradigm_home_product__mac__containner {
    background: url('~@/static/images/home-three-pc.png') no-repeat;
    background-size: contain;
    margin-top: 20px;
    padding-top: 23px;
    box-sizing: border-box;
  }
  .paradigm_home_product
    .paradigm_home_product__mac
    .paradigm_home_product__mac__containner
    .map1 {
    text-align: center;
    height: 200px;
  }
  .paradigm_home_product
    .paradigm_home_product__mac
    .paradigm_home_product__mac__containner
    .map1
    img {
    height: 120px;
  }
  .paradigm_home_product__text__containner {
    background: url('~@/static/images/home-mobile-text-1.png') no-repeat;
    background-size: 100% 100%;
    font-size: 12px;
    line-height: 25px;
    width: 100%;
    color: #333;
    padding: 20px 10px 20px 25px;
    text-align: left;
    height: 320px;
    z-index: 2000;
  }
  .paradigm_home_product__text__containner span {
    color: #29bdb9;
    font-weight: bold;
  }
  .paradigm_home_product .paradigm_home_product__list__item {
    line-height: 49px;
    cursor: pointer;
    font-size: 20px;
    color: #555;
    font-weight: 300;
    transition: all 0.1s;
  }
  .paradigm_home_product
    .paradigm_home_product__list__item
    .paradigm_home_product__list__item__symble {
    display: inline-block;
    padding-right: 12px;
    transition: all 0.3s;

    transform: rotate(70deg);
    margin-top: -5px;
    vertical-align: top;
    padding-left: 20px;
    font-weight: bold;
  }
  .paradigm_home_product .paradigm_home_product__list__item:hover,
  .paradigm_home_product .paradigm_home_product__list__item.active {
    color: #333333;
    font-size: 24px;
  }
}
@media screen and (max-width: 600px) {
  .paradigm_page_container {
    width: initial;
  }
}
</style>
<style lang='scss'>
@media screen and (max-width: 600px) {
  body .examinto-mobile {
    .paradigm_home_product .paradigm_home_product__list__item:hover,
    .paradigm_home_product .paradigm_home_product__list__item.active {
      font-size: 20px !important;
    }
    .el-carousel__container {
      height: 620px;
      .el-carousel__arrow {
        top: 3.9%;
        background-color: transparent;
        color: #333;
        font-size: 28px !important;
      }
      .el-carousel__arrow--left {
        left: 0;
      }
      .el-carousel__arrow--right {
        right: 6px;
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  body .examinto-mobile {
    .paradigm_home_product .paradigm_home_product__list__item:hover,
    .paradigm_home_product .paradigm_home_product__list__item.active {
      font-size: 20px !important;
    }
    .el-carousel__container {
      height: 620px !important;
      width: 100%;
      .el-carousel__arrow {
        top: 3.9%;
        background-color: transparent;
        color: #333;
        font-size: 28px !important;
      }
      .el-carousel__arrow--left {
        left: 0;
      }
      .el-carousel__arrow--right {
        right: 6px;
      }
      .paradigm_home_product__mac__containner {
        background-position: center !important;
        margin-bottom: 20px;
      }
    }
    .paradigm_home_product__text__containner {
      height: 270px !important;
      padding: 30px 20px 30px 35px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/examintro/mobile.vue